import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { CertForm } from "@/components/CertForm"
import { CertLookup } from "@/components/CertLookup"
import { CertStats } from "@/components/CertStats"
import { NumberDisplay } from "@/components/NumberDisplay"
import { Footer } from "@/components/Footer"
import { supabase } from "@/integrations/supabase/client"

const Index = () => {
  const [content, setContent] = useState({
    home_title: '成人认证系统',
    home_subtitle: '快速申请成人认证，实时邮件通知。',
    home_description: '专业的网站成人认证平台，提供快速的成人认证申请、查询和管理服务。',
    form_title: '申请认证',
    lookup_title: '查询认证',
    stats_title: '统计数据'
  });

  useEffect(() => {
    const fetchContent = async () => {
      console.log("Fetching home page content");
      const { data, error } = await supabase
        .from('site_content')
        .select('*')
        .in('key', [
          'home_title',
          'home_subtitle',
          'home_description',
          'form_title',
          'lookup_title',
          'stats_title'
        ]);

      if (error) {
        console.error("Error fetching home content:", error);
        return;
      }

      if (data) {
        const contentMap = data.reduce((acc: any, item) => {
          acc[item.key] = item.content;
          return acc;
        }, {});
        console.log("Fetched home content:", contentMap);
        setContent(prev => ({ ...prev, ...contentMap }));
      }
    };

    fetchContent();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a1c2e] to-[#2d1b4b]">
      <div className="container py-16 px-4">
        <div className="text-center mb-16 space-y-8 animate-fade-in">
          <div className="relative">
            <div className="absolute inset-0 blur-3xl bg-gradient-to-r from-blue-500/30 via-purple-500/30 to-pink-500/30 rounded-full transform -translate-y-1/2"></div>
            <h1 className="relative text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 mb-6 tracking-tight">
              {content.home_title}
            </h1>
          </div>
          <p className="text-gray-300 max-w-2xl mx-auto text-lg leading-relaxed">
            {content.home_subtitle}
          </p>
          <p className="text-gray-400 max-w-3xl mx-auto">
            {content.home_description}
          </p>
          
          <div className="flex justify-center gap-6 mt-12">
            <CertStats />
          </div>
        </div>
        
        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-8 shadow-2xl border border-white/10 transform hover:scale-[1.01] transition-all duration-300">
            <NumberDisplay className="animate-fade-in" />
          </div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="backdrop-blur-lg bg-white/5 rounded-2xl p-8 shadow-2xl border border-white/10 transform hover:translate-y-[-2px] transition-all duration-300">
            <Tabs defaultValue="apply" className="animate-fade-in">
              <TabsList className="grid w-full grid-cols-2 mb-8">
                <TabsTrigger 
                  value="apply"
                  className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-blue-500 data-[state=active]:to-purple-600 data-[state=active]:text-white py-3 transition-all duration-300"
                >
                  {content.form_title}
                </TabsTrigger>
                <TabsTrigger 
                  value="lookup"
                  className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-blue-500 data-[state=active]:to-purple-600 data-[state=active]:text-white py-3 transition-all duration-300"
                >
                  {content.lookup_title}
                </TabsTrigger>
              </TabsList>
              
              <div className="mt-4">
                <TabsContent value="apply" className="mt-6 animate-fade-in">
                  <CertForm />
                </TabsContent>
                <TabsContent value="lookup" className="mt-6 animate-fade-in">
                  <CertLookup />
                </TabsContent>
              </div>
            </Tabs>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default Index;